<div class="mt-2 ml-3 mr-3 pt-2">
  <div class="flex justify-content-between col-12 bg-white btn-with-links p-3">
    <label class="font-semibold uppercase category-name" translate>product.lbl_products</label>
    @if(isAllowToAddProduct) {
    <div>
      <p-button class="flex align-items-center justify-content-center mr-2" icon="pi pi-plus"
        label="Add Protocol Product" (click)="onAddProtocolProduct()"></p-button>
    </div>
    }
  </div>
  @if(data){
  <app-mi-table
    [collectionOfColumns]="allColumns"
    [attributeLabels]="filterAttributeLabels"
    [data]="tableData"
    entityName="protocol_product"
    [isEntity]="isEntity"
    [isLoading]="isLoading"
    (onPageChange)="onPageChange($event)"
    (itemPerPageChange)="itemPerPageChange($event)"
    [totalRecords]="totalRecords"
    [itemsPerPage]="itemsPerPage"
    [message]="deleteSiteMsg"
    [header]="deleteSiteHeaderMsg"
    (onDelete)="onVehicleDelete($event)"
    (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
    [filterList]="[]"
    (onValueChange)="onFilterValueChange($event)"
    [filterFields]="filterFieldsArray"
    [label]="btnLabel"
    (onBtnClick)="onAddVehicle()"
    [bulkUpdateLabel]="bulkUpdateLabel"
    [bulkDeleteLabel]="bulkDeleteLabel"
    [attributeData]="attributeData"
    (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
    (onSearchValueChange)="onSearchValueChanges($event)"
    (onUpdate)="onUpdateProduct($event)"
    [rowItems]="rowItems"
    [bulkSelectionsItems]="bulkSelectionsItems"
    (setCurrentRowData)="setCurrentRowData($event)"
    [visiblePrintLabel]="visiblePrintLabel"
    [showBulkUpdateDialog]="showBulkUpdateDialog"
    (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
    [visible]="visible"
    [bulkUpdateHeader]="bulkUpdateHeader"
    [reviewHeader]="reviewHeader"
    [btnUpdate]="btnUpdate"
    (onSortData)="onSortData($event)">
  </app-mi-table>
  }
</div>

@if(showAddProtocolProductDialog) {
<app-add-protocol-product
  #addProtocolProduct
  [protocolEntityId]="trialId"
  [protocolProductId]="protocolProductId"
  [showAddProtocolProductDialog]="showAddProtocolProductDialog"
  (saveSuccess)="onSaveSuccess()"
  (onToggleOverLay)="onToggleOverlayForAdd()"
  (closePopup)="onClosePopup($event)"
  [isChangeReasonNotRequired]="isChangeReasonNotRequired"
  [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus">
</app-add-protocol-product>
}